module.exports = __webpack_public_path__ + "img/close.02a45e1c.svg";